module.exports = __webpack_public_path__ + "img/slogan.1d53b1c4.png";